import clsx from 'clsx'
import type { NewsletterStatus } from '@/lib/newsletter-types'

const LABEL: Record<NewsletterStatus, string> = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  sending: 'Sending',
  sent: 'Sent',
  canceled: 'Canceled',
  failed: 'Failed',
}

const TONE: Record<NewsletterStatus, string> = {
  draft: 'bg-[var(--surface-nested)] text-[var(--content-secondary)]',
  scheduled: 'bg-blue-500/15 text-blue-700 dark:text-blue-300',
  sending: 'bg-yellow-500/15 text-yellow-700 dark:text-yellow-300',
  sent: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  canceled: 'bg-slate-500/15 text-slate-600 dark:text-slate-400',
  failed: 'bg-red-500/15 text-red-700 dark:text-red-300',
}

export function NewsletterStatusPill({ status }: { status: NewsletterStatus }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider',
        TONE[status] ?? TONE.draft,
      )}
    >
      {LABEL[status] ?? status}
    </span>
  )
}
